import { render } from "./SectionNav.vue?vue&type=template&id=60aba80a&scoped=true"
import script from "./SectionNav.vue?vue&type=script&lang=js"
export * from "./SectionNav.vue?vue&type=script&lang=js"

import "./SectionNav.vue?vue&type=style&index=0&id=60aba80a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-60aba80a"

export default script